<template>
    <div>
        <template v-if="viewPage == true && leaveCrud == true">
            <form id="teamForm" @submit.prevent="addTeamDetail">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Team </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/teams" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list active">
                            <span class="status-highlighter">1</span>
                            Team Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">2</span>
                            Add Team Members
                        </li>
<!--                        <li class="page-status-list">-->
<!--                            <span class="status-highlighter">3</span>-->
<!--                            Confirmation Message-->
<!--                        </li>-->
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Team Name <em class="required">*</em> </label>
                                    <input v-model="form.team_name" type="text" name="team_name" class="form-control" :class="{ 'is-invalid': form.errors.has('team_name') }">
                                    <has-error :form="form" field="team_name"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Manager  <em class="required">*</em> </label>
                                    <select v-model="form.manager_id" name="manager_id" data-live-search="true" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('manager_id') }" v-if="managers != null">
                                        <option value="" selected>Select Manager</option>
                                        <option v-for="manager in managers" v-bind:value="manager.id" v-bind:key="manager.id">
                                            {{ manager.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="manager_id"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Team Lead  <em class="required">*</em> </label>
                                    <select v-model="form.team_lead_id" name="team_lead_id" data-live-search="true" multiple class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('team_lead_id') }" v-if="team_leads != null">
                                        <option value="" selected>Select Team Lead</option>
                                        <option v-for="team_lead in team_leads" v-bind:value="team_lead.id" v-bind:key="team_lead.id">
                                            {{ team_lead.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="team_lead_id"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Department</label>
                                    <select v-model="form.department_id" name="department_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('department_id') }" v-if="departments != null">
                                        <option value="" selected>Select Department</option>
                                        <option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id">
                                            {{ department.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="department_id"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Branch </label>
                                    <select v-model="form.branch_id" name="branch_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('branch_id') }" v-if="branches != null">
                                        <option value="" selected>Select Branch</option>
                                        <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">
                                            {{ branch.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="branch_id"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> City <em class="required">*</em> </label>
                                    <select v-model="form.city_id" name="city_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('city_id') }" v-if="cities != null">
                                        <option value="" selected>Select City</option>
                                        <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                            {{ city.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="city_id"></has-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="viewPage === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="viewPage === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                viewPage: null,
                leaveCrud: false,
                form: new Form({
                    team_name : '',
                    team_lead_id : [],
                    city_id : '',
                    branch_id : '',
                    department_id : '',
                    manager_id : '',
                }),
                team_leads : null,
                cities : null,
                branches: null,
                departments: null,
                managers: null,
            }
        },
        methods: {
            addTeamDetail() {
                this.$Progress.start();
                this.form.post('api/addTeamDetail')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Team detail added successfully'
                        });
                        this.$router.push('/addTeamMembers/'+res.data.data.id);
                    }else{
                        this.$Progress.fail();
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            getAddTeamDetailData(){
                this.$Progress.start();
                axios.get('/api/addTeamDetailData')
                .then(res => {
                    if(res.status == 200){
                        this.team_leads = res.data.users;
                        this.cities = res.data.cities;
                        this.branches = res.data.branches;
                        this.departments = res.data.departments;
                        this.managers = res.data.users;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        swal.fire({
                            type: 'error',
                            title: 'Error to load form data'
                        });
                    }
                }).then(res => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('team|team_member').then(result => {
                this.viewPage = result.team;
                this.leaveCrud = result.team_member;
                // this.$Progress.finish();
            }).then(result => {
                this.getAddTeamDetailData();
                $('.selectpicker').selectpicker();
            });
        }
    }
</script>
